
















import { Component, Mixins, Prop } from "vue-property-decorator";
import { SingleOptionSelectableMixin } from "./mixins";

@Component({
})
export default class OptionRadioSelector extends Mixins(SingleOptionSelectableMixin) {
  @Prop({ default: "standard" })
  type: string;
}
